import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTier } from '../../../../contexts/TierContext';
import accoladeLogo from '../../../../assets/Logo-Accolade-light-2.png';
import partnerLogo from '../../../../assets/Tri-Brand_footer-2.png';
import PDFViewer from '../../../../components/PDFViewer/PDFViewer';
import benefitsPDFEn from '../../../../assets/pdfs/English-Tier-Benefits.pdf';
import benefitsPDFFr from '../../../../assets/pdfs/French-Tier-Benefits.pdf';
import './LoyaltyCard.scss';

interface LoyaltyCardProps {
  memberCardNumber: string;
  memberName: string;
  memberSince: string;
}

export const LoyaltyCard: React.FC<LoyaltyCardProps> = ({
  memberCardNumber,
  memberName,
  memberSince,
}) => {
  const { t, i18n } = useTranslation('home');
  const { tier } = useTier();
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  // Return the appropriate PDF based on current language
  const getPdfLink = () => {
    return i18n.language === 'fr' ? benefitsPDFFr : benefitsPDFEn;
  };

  // Toggle PDF viewer visibility
  const togglePdfViewer = () => {
    setShowPdfViewer(!showPdfViewer);
  };

  return (
    <div className={`loyalty-card loyalty-card--${tier}`}>
      <div className="loyalty-card__header">
        <div className="loyalty-card__brand">
          <img src={accoladeLogo} alt="Accolade" />
        </div>
        <div className="loyalty-card__tier-group">
          <span className="loyalty-card__tier-label">{t('loyalty.tierGroup')}:</span>
          <span className="loyalty-card__tier-value">{t(`dashboard.tiers.${tier}`).toUpperCase()}</span>
        </div>
      </div>
      <div className="loyalty-card__user-info">
        <div className="loyalty-card__card-number">{memberCardNumber}</div>
        <div className="loyalty-card__member-name">{memberName}</div>
      </div>
      <div className="loyalty-card__divider"></div>
      <div className="loyalty-card__footer">
        <div className="loyalty-card__footer-left">
          <span className="loyalty-card__member-since">
            {t('loyalty.memberSince')} {memberSince}
          </span>
        </div>
        <div className="loyalty-card__partner-logos">
          <img src={partnerLogo} alt="Partner" />
        </div>
      </div>

      <div className="loyalty-card__benefits-section">
        <button className="loyalty-card__benefits-link" onClick={togglePdfViewer}>
          {t('loyalty.yourBenefits')}
        </button>
      </div>

      {showPdfViewer && (
        <PDFViewer
          pdfUrl={getPdfLink()}
          onClose={() => setShowPdfViewer(false)}
        />
      )}
    </div>
  );
};

export default LoyaltyCard;
